import React, { useEffect, useState } from 'react';
import { getBanners } from '../../api/strapi';
import { Box, IconButton, useMediaQuery } from '@mui/material';
import { CloseIcon } from '../../kit/icons/CloseIcon';
import PriceIncreaseBanner from './banners/PriceIncreaseBanner/PriceIncreaseBanner';
import ModalBlock from '../ModalBlock/ModalBlock';
import ConsultationModal from '../Modals/ConsultationModal';
import VioletTimerBanner from './banners/VioletTimerBanner/VioletTimerBanner';
import SummerSpringBanner from './banners/SummerSpringBanner/SummerSpringBanner';
import AutumnBanner from './banners/AutumnBanner/AutumnBanner';
import BlackFridayBanner from './banners/BlackFriday/BlackFridayBanner';

const formData = {
  title: 'Оставить заявку чтобы узнать детали',
  sentContent: {
    title: 'Заявка принята!',
    message: 'Скоро с вами свяжется куратор',
  },
};

const extraLeadData = {
  leadAction: 'Заявка на бронирование',
  leadBlock: 'Баннер',
  eventName: 'Заявка на бронирование по старой цене',
};

const lightThemesBanners = ['spring_summer'];

export default function Banner() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [strapiBanner, setStrapiBanner] = useState(null);
  const tags = strapiBanner?.tags ? [...strapiBanner.tags.split(',')] : null;
  const closeIconColor = lightThemesBanners.includes(
    strapiBanner?.bannerBackground,
  )
    ? 'black'
    : 'white';

  const needShowBanner = () => {
    const dateSavedEarlierYeaterday =
      Date.now() - new Date(localStorage.getItem('bannerIsShowed')).getTime() >
      1000 * 3600 * 24;

    return isNaN(dateSavedEarlierYeaterday) || dateSavedEarlierYeaterday;
  };
  const [showBanner, setShowBanner] = useState(needShowBanner());

  useEffect(() => {
    const ac = new AbortController();

    const getBannersList = async () => {
      try {
        const banners = await getBanners(ac);
        const sortCompareDates = (a, b) =>
          new Date(a.expireDate).getTime() - new Date(b.expireDate).getTime();
        const currentBanners = banners
          .filter(
            (banner) =>
              banner.enableBanner &&
              new Date(banner.expireDate).getTime() > Date.now(),
          )
          .sort(sortCompareDates);
        setStrapiBanner(currentBanners[0]);
      } catch (error) {
        console.warn('Unable to get banner information', error);
      }
    };

    getBannersList();
    return () => ac.abort();
  }, []);

  // Empty on purpose for now
  const handleClick = () => {};

  const handleClose = () => {
    localStorage.setItem('bannerIsShowed', new Date());
    setShowBanner(false);
  };

  const handleSuccessSend = (result) => {
    if (result) {
      setTimeout(() => {
        setShowBanner(false);
        localStorage.setItem('bannerIsShowed', strapiBanner.expireDate);
      }, [3000]);
    }
  };

  if (!strapiBanner || !showBanner) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'relative',
      }}
    >
      {strapiBanner.bannerBackground === 'price_increase' && (
        <PriceIncreaseBanner
          banner={strapiBanner}
          isMobile={isMobile}
          setIsModalOpen={setIsModalOpen}
          handleClick={handleClick}
          setShowBanner={setShowBanner}
        />
      )}
      {strapiBanner.bannerBackground === 'violet_timer' && (
        <VioletTimerBanner
          banner={strapiBanner}
          isMobile={isMobile}
          setIsModalOpen={setIsModalOpen}
          handleClick={handleClick}
          setShowBanner={setShowBanner}
        />
      )}
      {strapiBanner.bannerBackground === 'spring_summer' && (
        <SummerSpringBanner
          banner={strapiBanner}
          isMobile={isMobile}
          setIsModalOpen={setIsModalOpen}
          handleClick={handleClick}
          setShowBanner={setShowBanner}
        />
      )}
      {strapiBanner.bannerBackground === 'autumn' && (
        <AutumnBanner
          banner={strapiBanner}
          isMobile={isMobile}
          setIsModalOpen={setIsModalOpen}
          handleClick={handleClick}
          setShowBanner={setShowBanner}
        />
      )}
      {strapiBanner.bannerBackground === 'black_friday' && (
        <BlackFridayBanner
          banner={strapiBanner}
          isMobile={isMobile}
          setIsModalOpen={setIsModalOpen}
          handleClick={handleClick}
          setShowBanner={setShowBanner}
        />
      )}
      <IconButton
        onClick={handleClose}
        sx={(theme) => ({
          position: 'absolute',
          top: '50%',
          right: 0,
          transform: 'translate(-25%, -50%)',
          [theme.breakpoints.down('sm')]: {
            transform: 'translate(-5%, -50%)',
          },
        })}
      >
        <CloseIcon
          color={closeIconColor}
          sx={{ width: { xs: 14, lg: 24 }, height: { xs: 14, lg: 24 } }}
        />
      </IconButton>
      <ModalBlock
        isOpen={isModalOpen}
        handleClose={() => {
          setIsModalOpen(false);
        }}
      >
        <ConsultationModal
          extraLeadData={{ ...extraLeadData, tags }}
          formData={formData}
          successSend={handleSuccessSend}
          buttonLabel={'Оставить заявку'}
          ymSubmitEventType="leadFromBannerPrice"
        />
      </ModalBlock>
    </Box>
  );
}
